
<template>
    <el-dialog :title="textMap[title]" width="900px" @close="close" :visible.sync="dialogFormVisible">
        <avue-form ref="form" v-model="obj" :rules="rules" :option="option">
            <template slot="menuForm">
                <el-button  @click="close">取 消</el-button>
                <el-button type="primary" @click="change_pwd">确 定</el-button>
            </template>
        </avue-form>
    </el-dialog>
</template>
<script>
import {addObj,putObj,roleList} from '@/api/admin/user'
import {fetchTree} from '@/api/admin/dept'
import {formatSelectTree,dealElement} from '@/util/util'
import waves from '@/directive/waves/index.js' // 水波纹指令
import {objKeySort} from '@/util/ajaxsign'
import {phone,email,validatePass,validatePass2} from "@/util/Format"
import { unlink } from 'fs';
export default {
    name: 'table_user',
    directives: {
        waves
    },
    data() {
        return {
            title : '',
            textMap: {
                update: '编辑用户',
                create: '创建用户'
            },
            userId : '',
            dialogFormVisible : false,
            obj : {},
            rules : {},
            option:{
                emptyBtn:false,
                submitBtn:false,
                submitText : '确定',
                column: [ {
                  label: "账户",
                  prop: "account",
                  disabled : false,
                  span:12,
                  rules : [
                    {required: true, message: '请输入账户', trigger: 'blur' },
                    {min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur'}
                  ]
              },{
                  label: "姓名",
                  prop: "name",
                  span:12,
                  rules : [
                    {required: true, message: '请输入名称', trigger: 'blur' },
                  ]
              },{
                  label: "密码",
                  prop: "password",
                  type : "password",
                  visdiplay : true,
                  span:12,
                  rules: [{ required: true,validator: validatePass, trigger: 'blur' }]
              },{
                  label: "确认密码",
                  prop: "password1",
                  type : "password",
                  visdiplay : true,
                  span:12,
                  rules: [{ required: true,validator: validatePass2, trigger: 'blur' }]
              },{
                  label: "性别",
                  prop: "sex",
                  type: "select",
                  dicData:[
                      {label:'男',
                      value:1},
                      {label:'女',
                      value:2}
                  ],
                  span:12
              },{
                label: "E-mail",
                prop: "email",
                span:12,
                rules: [{ validator: email, trigger: 'blur' }]
              },{
                label: "手机",
                prop: "phone",
                span:12,
                rules: [{required: true, validator: phone, trigger: 'blur' }]
              },{
                label: "部门",
                prop: "deptId",
                type: "tree",
                span:12,
                dicUrl : '/dept/tree',
                dicMethod:"post",
                dicQuery : objKeySort({}),
                props : {
                    label: 'name',
                    value: 'id'
                }
              }
              ,{
                label: "角色",
                prop: "roleId",
                span:12,
                visdiplay : true,
                rules : [ { required: true, message: '请选择角色', trigger: 'blur'}],
                type: 'select',
                dicUrl : '/role/roleList',
                dicMethod:"post",
                dicQuery : objKeySort({}),
                props : {
                    label: 'roleName',
                    value: 'roleId'
                }
              }
              ,{
                label: "状态",
                type: "select",
                prop: "delFlag",
                visdiplay : true,
                span:12,
                dicData:[{
                    value: 1,
                    label: '启用'
                }, {
                    value: 2,
                    label: '冻结'
                }, {
                    value: 3,
                    label: '删除'
                }]
              }],
            },
        }
    },
    created() {},
    methods: {
        //展示弹出层
        dialog(title,data){
            this.title = title;
            this.setcolumn();
            if(data.roleId){
                data.roleId =  parseInt(data.roleId);
            }
            this.obj = data;
            this.dialogFormVisible = true; 
        },

        //处理coulmn数据
        setcolumn(){
            if(this.title == "create"){
                for(var i=0;i<this.option.column.length;i++){
                    if(this.option.column[i].prop == "account"){
                        this.option.column[i].disabled  = false;
                    }
                    if(this.option.column[i].prop == "password"){
                        this.option.column[i].visdiplay  = true;
                    }
                    if(this.option.column[i].prop == "password1"){
                        this.option.column[i].visdiplay  = true;
                    }
                    if(this.option.column[i].prop == "roleid"){
                        this.option.column[i].visdiplay  = true;
                    }
                    if(this.option.column[i].prop == "delFlag"){
                        this.option.column[i].visdiplay  = true;
                    }
                }
            }else{
                for(let i=0;i<this.option.column.length;i++){
                    if(this.option.column[i].prop == "account"){
                        this.option.column[i].disabled  = true;
                    }
                    if(this.option.column[i].prop == "password"){
                        this.option.column[i].visdiplay  = false;
                    }
                    if(this.option.column[i].prop == "password1"){
                        this.option.column[i].visdiplay  = false;
                    }
                }
            }
            
        },

        //对表单数据进行初始化
        rolecolum(data,dict){
            for(var i=0;i<this.option.column.length;i++){
                if(this.option.column[i].prop == data){
                    this.option.column[i].dicData = dict;
                }
            }
        },

        close(){
            this.obj= {};
            this.$refs.form.clearValidate();
            this.dialogFormVisible = false;
        },

        handleEmpty(){
            this.obj= {};
            this.$refs.form.clearValidate();
            this.dialogFormVisible = false;
        },

        //处理数据
        change_pwd(){
            if(this.title == "create"){
                this.addObj()
            }else{
                this.update()
            }
        },

        //新增数据操作
        addObj(){
            this.$refs.form.validate(vaild=>{
                if(vaild){
                     addObj(objKeySort(this.obj)).then(res => {
                        this.$message({
                            title: '成功',
                            message: '创建成功',
                            type: 'success',
                            duration: 2000
                        })
                        window.sessionStorage.removeItem("password")
                        this.handleEmpty();
                        this.$emit('refresh','');
                    })
                }
            })
        },

        //修改数据
        update(){
            this.$refs.form.validate(vaild=>{
                if(vaild){
                    this.obj = JSON.parse(JSON.stringify(this.obj).replace(/id/g,"userId"));
                    delete this.obj.$index;
                    putObj(objKeySort(dealElement(this.obj))).then(() => {
                    this.$message({
                        title: '成功',
                        message: '修改成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.handleEmpty();
                    this.$emit('refresh','');
                    })
                }
            })

        }
    }
}
</script>
